import { HandleType, Position } from "@xyflow/react";
import { BusCompSvg, PayloadCompSvg } from "./Svgs";

export const DEFAULT_NODES = [
    {
        id: '1',
        data: {
            label: 'Remote Connection',
            disabled: true,
            rootNode: true,
            handlers: [
                { id: 'left', type: 'source' as HandleType, position: Position.Left },
                { id: 'right', type: 'source' as HandleType, position: Position.Right }
            ],
        },
        position: { x: 300, y: 100 },
        type: 'custom',
    },
    {
        id: '2',
        data: {
            label: 'Payload Components',
            category: 'Payload',
            componentType: 'SWIL',
            icon: <PayloadCompSvg />,
            disabled: true,
            subRootNode: true,
            handlers: [
                { id: 'top', type: 'target' as HandleType, position: Position.Top },
                { id: 'bottom', type: 'source' as HandleType, position: Position.Bottom }
            ],
        },
        position: { x: 0, y: 250 },
        type: 'custom',
    },
    {
        id: '3',
        data: {
            label: 'Bus Components',
            category: 'Bus',
            componentType: 'SWIL',
            disabled: true,
            icon: <BusCompSvg />,
            handlers: [
                { id: 'top', type: 'target' as HandleType, position: Position.Top },
                { id: 'bottom', type: 'source' as HandleType, position: Position.Bottom }
            ],
            subRootNode: true,
        },
        position: { x: 600, y: 250 },
        type: 'custom',
    },
]

const getDefaultNodes = (categories: string[], selected_satellite: string) => {
    return DEFAULT_NODES.map(node => {
        if (categories.includes(node?.data?.category || '')) {
            return {
                ...node,
                data: {
                    ...node.data,
                    label: node.id === '1' ? selected_satellite : node?.data?.label,
                }
            };
        }
        return {
            ...node,
            data: {
                ...node.data,
                label: node.id === '1' ? selected_satellite : node?.data?.label
            }
        };
    });
}

export function getDefaultNodesByCategory(categories: string[], selected_satellite: string) {
    // If both categories are present, return the original array
    if (categories.includes('Payload') && categories.includes('Bus')) {
        return getDefaultNodes(categories, selected_satellite);
    }
    return [{
        ...DEFAULT_NODES[0],
        data: {
            icon: categories.includes('Payload') ? <PayloadCompSvg /> : <BusCompSvg />,
            label: `${categories[0]} Components`,
            category: categories[0],
            componentType: 'SWIL',
            subRootNode: true,
            handlers: [
                { id: 'bottom', type: 'source' as HandleType, position: Position.Bottom }
            ],
        }
    }];
}
